import { useContext, useState } from "react"
import { LanguageContext, NotificationContext } from "../context"

const MessageModal = ({ title, onClose, onSend, showModal }) => {

  const { t } = useContext(LanguageContext)
  const { toast } = useContext(NotificationContext)

  const [message, setMessage] = useState('')
  const [sending, setSending] = useState(false)

  const handleSend = async () => {
    const processedMessage = message.trim()
    if(!processedMessage) {
      toast({ message: t('message.empty_error'), variant: 'error' })
      return
    }
    setSending(true)
    const response = await onSend(processedMessage)
    setSending(false)
    if(response.error) {
      toast({ message: response.error.message, variant: 'error' })
      return 
    }
    setMessage('')
    onClose()
    toast({ message: t('message.sent_toast'), variant: 'success' })
  }

  const handleClose = () => {
    setMessage('')
    onClose()
  }

  return (
    <div className={`w-full ${showModal ? '' : 'hidden'}`}>
      <div
        className="justify-center items-center z-60 rounded-lg modal-container ">
        <div className="flex items-start justify-between pt-16 pb-9 px-5  ">
          <h3 className="modal-title">
            {t('message.title')}
          </h3>
          <button
            className="p-1 bg-transparent text-black text-3xl absolute top-2 right-4"
            onClick={handleClose}
          >
            ×
          </button>
        </div>
        <div className="modal-box">
          <div className="modal-body">
            <div className="flex flex-col gap-4">
              <textarea
                className="w-full h-40 border border-gray-300 rounded-md p-4"
                placeholder={t('message.placeholder')}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
              <div className="flex gap-4 mt-6">
                <button
                  className="flex primary-border mid"
                  onClick={handleClose}
                >
                  {t('generic.cancel')}
                </button>
                <button
                  className={`flex primary mid btn-loading ${sending ? 'running' : ''}`}
                  onClick={handleSend}
                >
                  <div className="loading"></div>
                  {t('generic.send')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="fixed inset-0 z-50 modal-bg" onClick={handleClose}></div>
    </div>
  )
}

export default MessageModal